import React, { useEffect, useState, } from 'react'
import { Modal } from 'react-bootstrap';
import HtmlParser from 'react-html-parser';

import {
    responseGet, globalSettings, numberSet, separatorsNumbersSet, styles, validateDecimals, languageObjGet, isUndNullEmp, sendMessageCloseCurrentWindowAsync, buttonProcessGet,
    awaitDelay
} from '../../helpers/settings'
import { GlobalFormats } from '../../classes/main/globalFormats';
import { expenseTemplateDetailModelGet, expenseTemplateModelGet } from '../../models/expenses/template';

const currentMethod = 'ConceptEdit';

export default function ConceptEdit({
    $ = {},
    auth = {},
    neutralValue = 0.00,
    conceptId = '',
    template = expenseTemplateModelGet({}),
    useRole = '',
    showModal = false,
    setShowModal = () => { },
    dtConceptsId = '',
    dtConcepts = {},
    rowIndex = 0,
    expenseTemplateBalanceGetAsync = async ({ subMethod = '', }) => { },
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    const [priceError, setPriceError] = useState('');
    const [quantityError, setQuantityError] = useState('');
    const [concept, setConcept] = useState(expenseTemplateDetailModelGet({}));
    const controls = {
        buttons: {
            save: {
                id: 'btnModalConceptEditSave',
                className: 'btn btn-outline-warning mx-1',
            },
            back: {
                id: 'btnModalConceptEditBack',
                className: 'btn btn-outline-success mx-1',
            },
            close: {
                id: 'btnModalConceptEditClose',
                className: 'close btn-danger fas fa-window-close',
            },
        },
        inputs: {
            quantity: {
                id: 'inputModalConceptEditQuantity',
                className: 'form-control text-right',
            },
            price: {
                id: 'inputModalConceptEditPrice',
                className: 'form-control text-right',
            },
        },
        dataTables: {
            conceptsFind: {
                buttons: {
                    // create: {
                    //     className: 'btn btn-outline-success float-right btn-sm',
                    //     id: 'btnDtExpenseConceptsCreate',
                    // },
                },
                icons: {
                    // create: {
                    //     id: 'iconDtExpenseConceptsCreate',
                    //     className: globalSettings?.icons?.plusCircle,
                    // },
                },
                inputs: {
                    // search: {
                    //     id: `${dtConceptsFindId}_filter input`,
                    //     className: '',
                    // },
                },
                selects: {
                    // entries: {
                    //     id: `${dtConceptsFindId}_length select`,
                    //     className: '',
                    // },
                },
                spinners: {
                    // create: {
                    //     id: 'spDtExpenseConceptsCreate',
                    //     className: '',
                    // },
                },
            },
        },
        icons: {
            save: {
                id: 'icoModalConceptEditSave',
                className: globalSettings?.icons?.save,
            },
            back: {
                id: 'icoModalConceptEditBack',
                className: globalSettings?.icons?.arrowCircleLeft,
            },
        },
        spinners: {
            save: {
                id: 'spModalConceptEditSave',
                className: '',
            },
            back: {
                id: 'spModalConceptEditBack',
                className: '',
            },
        },
    };
    //#endregion variables

    //#region methods
    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            const conceptLocal = template?.details?.find(({ id, }) => id === conceptId);
            if (!isUndNullEmp({ data: conceptLocal, subMethod: currentMethod, })?.result) {
                setConcept(conceptLocal);
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const defaultValueSetAsync = async ({ isModalClose = false, subMethod = '', }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            await errosDefaultSetAsync({ subMethod: currentMethod });

            if (isModalClose) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            }

            setShowModal(!isModalClose);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const formDataSetAsync = async ({ property = '', value = '', subMethod = '', }) => {
        const currentMethod = 'formDataSetAsync';
        let response = responseGet();
        try {
            setConcept({ ...concept, [property]: value, });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const formDataValidateAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'formDataValidateAsync';
        let response = responseGet();
        try {
            //#region variables
            const neutralValueStr = separatorsNumbersSet({
                number: neutralValue,
                withDecimals: true,
                consoleLogErrorShow: true,
                subMethod: currentMethod,
            })?.result
            concept.quantity = parseFloat(Number(concept?.quantity)?.toFixed(globalSettings?.numberPositions?.decimalPlaces));
            concept.price = parseFloat(Number(concept?.price)?.toFixed(globalSettings?.numberPositions?.decimalPlaces));
            //#endregion variables

            //#region methods
            if (concept.quantity <= neutralValue) {
                setQuantityError(`${globalSettings?.messages?.mustBeGreaterThan?.[languageObj?.id]} <b>${neutralValueStr}</b>`);
                response.isWarning = true;
            }

            if (concept.price <= neutralValue) {
                setPriceError(`${globalSettings?.messages?.mustBeGreaterThan?.[languageObj?.id]} <b>${neutralValueStr}</b>`);
                response.isWarning = true;
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const errosDefaultSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'errosDefaultSetAsync';
        let response = responseGet();
        try {
            setPriceError('');
            setQuantityError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const conceptEditPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'conceptEditPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e.preventDefault();
            }

            //#region initialize
            response = await errosDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion initialize

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            template.details = template?.details?.filter(({ id }) => id !== concept?.id);
            template?.details?.push(concept);

            //#region old code
            // $(`#${dtConceptsId}`)?.DataTable()?.row(rowIndex)?.data?.([
            //     concept.description,
            //     separatorsNumbersSet(concept.quantity),
            //     separatorsNumbersSet(concept.price),
            //     separatorsNumbersSet(numberSet((concept.quantity * concept.price), 'd')),
            //     getButtonProcessTwo(concept.id, concept.description, false, true, true).result,
            // ])?.draw(true);
            //#endregion old code

            //#region variables
            const quantity = separatorsNumbersSet({
                number: concept?.quantity,
                withDecimals: true,
                consoleLogErrorShow: true,
                subMethod: currentMethod,
            })?.result;
            const price = separatorsNumbersSet({
                number: concept?.price,
                withDecimals: true,
                consoleLogErrorShow: true,
                subMethod: currentMethod,
            })?.result;
            const subTotal = separatorsNumbersSet({
                number: (concept?.quantity * concept?.price),
                withDecimals: true,
                consoleLogErrorShow: true,
                subMethod: currentMethod,
            })?.result;
            //#endregion variables

            //#region dtExpenseTemplate update
            $(`#${dtConceptsId}`)?.DataTable()?.row(rowIndex)?.data?.([
                concept.description,
                quantity,
                price,
                subTotal,
                buttonProcessGet({
                    id: concept?.id,
                    description: concept?.description,
                    showDetails: false,
                    labelDetails: globalSettings?.labels?.detail?.[languageObj?.id],
                    enabledDetails: false,
                    showEdit: true,
                    labelEdit: globalSettings?.labels?.edit?.[languageObj?.id],
                    enabledEdit: true,
                    showDelete: true,
                    labelDelete: globalSettings?.labels?.delete?.[languageObj?.id],
                    enabledDelete: true,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result,
            ])?.draw(true);
            //#endregion dtExpenseTemplate update

            //#region expenseTemplateBalance update
            response = await expenseTemplateBalanceGetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                return;
            }
            //#endregion expenseTemplateBalance update

            //#region form clear
            response = await defaultValueSetAsync({
                isModalClose: false,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                return;
            }
            //#endregion form clear

            await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.inputs?.quantity?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.price?.id}`)?.attr('readOnly', (processType !== 0));
            //#endregion controls

             //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

           //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

             //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTable
            // $(`#${controls?.dataTables?.conceptsFind?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            // $(`#${controls?.dataTables?.conceptsFind?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));
            //#endregion dataTable

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
    }, []) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <Modal backdrop='static' show={showModal} onHide={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - onHide' })}>
            <Modal.Header>
                <Modal.Title>
                    <img alt={globalSettings?.labels?.concept?.[languageObj?.id]}
                        src={globalSettings?.images?.expenseConceptsLogo}
                        style={styles?.cardHeaderLogo}>
                    </img> - {globalSettings?.labels?.concept?.[languageObj?.id]} ({globalSettings?.labels?.edit?.[languageObj?.id]?.toLowerCase()})
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnClose' })}>
                </button>
            </Modal.Header>
            <form onSubmit={(e) => conceptEditPostAsync({ e: e, subMethod: 'form - onSubmit', })}>
                <Modal.Body>
                    {/* <div className='card card-primary card-outline shadow' > */}
                    {/* <form onSubmit={(e) => conceptEditPostAsync(e)}> */}
                    {/* <div className='card-header'>
                            <h6 className='card-title'><img alt={globalSettings?.labels?.concept?.[languageObj?.id]} src={globalSettings?.images?.expenseConceptsLogo} style={styles?.cardHeaderLogo}></img> - {globalSettings?.labels?.concept?.[languageObj?.id]}</h6>
                        </div> */}

                    {/* <div className='card-body'> */}
                    <ul id='nothing' className='products-list product-list-in-card pl-2 pr-2'>
                        <li className='item'>
                            {/* <div className='product-img'>
                                <img alt={globalSettings?.labels?.concept?.[languageObj?.id]} src={globalSettings?.images?.expenseConceptsLogo} className='img-size-50'></img>
                            </div> */}
                            <div className='product-info'>
                                <a href='#nothing' className='product-title'>{template?.description || ''}</a>
                                <span className='badge badge-warning float-right'>{
                                    separatorsNumbersSet({
                                        number: numberSet({
                                            number: ((concept?.quantity || neutralValue) * (concept?.price || neutralValue)),
                                            type: 'd',
                                            subMethod: 'badge - right',
                                        })?.result,
                                        withDecimals: true,
                                        consoleLogErrorShow: true,
                                        subMethod: 'badge - right',
                                    })?.result
                                }</span>
                                <span className='product-description'>
                                    {concept?.description || ''}
                                </span>
                            </div>
                        </li>
                    </ul>

                    <div className='row'>
                        <div className='col-md-6'>
                            <div className='form-group'>
                                <div className='input-group mb-3'>
                                    <input id={controls?.inputs?.quantity?.id}
                                        className={controls?.inputs?.quantity?.className}
                                        //autoFocus
                                        onChange={(e) =>
                                            formDataSetAsync({
                                                property: 'quantity',
                                                value: validateDecimals({
                                                    e: e,
                                                    languageId: languageObj?.id,
                                                    subMethod: 'input - quantity'
                                                }),
                                                subMethod: 'input - quantity',
                                            })
                                        }
                                        onFocus={() => setQuantityError('')}
                                        placeholder={globalSettings?.labels?.quantity?.[languageObj?.id]}
                                        tooltip='tooltip' title={globalSettings?.labels?.quantity?.[languageObj?.id]}
                                        //value={!isUndefined(concept.quantity) ? concept.quantity : neutralValue} />
                                        value={concept?.quantity || '0.00'} />
                                    <div className='input-group-append'>
                                        <div className='input-group-text'>
                                            <span className={globalSettings?.icons?.sortNumericUpAlt} />
                                        </div>
                                    </div>
                                </div>
                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(quantityError)}</div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='form-group'>
                                <div className='input-group mb-3'>
                                    <input id={controls?.inputs?.price?.id}
                                        className={controls?.inputs?.price?.className}
                                        //onChange={(e) => formDataSetAsync('price', validateDecimals(e))}
                                        onChange={(e) =>
                                            formDataSetAsync({
                                                property: 'price',
                                                value: validateDecimals({
                                                    e: e,
                                                    languageId: languageObj?.id,
                                                    subMethod: 'input - price'
                                                }),
                                                subMethod: 'input - price',
                                            })
                                        }
                                        onFocus={() => setPriceError('')}
                                        placeholder={globalSettings?.labels?.price?.[languageObj?.id]}
                                        tooltip='tooltip' title={globalSettings?.labels?.price?.[languageObj?.id]}
                                        //value={!isUndefined(concept.price) ? concept.price : neutralValue} />
                                        value={concept?.price || '0.00'} />
                                    <div className='input-group-append'>
                                        <div className='input-group-text'>
                                            <span className={globalSettings?.icons?.moneyBillWave} />
                                        </div>
                                    </div>
                                </div>
                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(priceError)}</div>
                            </div>
                        </div>
                    </div>
                    {/* </div> */}

                    {/* <div className='card-footer'>
                            <div className='form-group text-right'>
                                <button className='btn btn-outline-warning mx-1'
                                    tooltip='tooltip'
                                    title={globalSettings?.labels?.save?.[languageObj?.id]}
                                    type='submit'>
                                    <i className={globalSettings?.icons?.save}></i>
                                </button>
                                <button className='btn btn-outline-success'
                                    tooltip='tooltip'
                                    title={globalSettings?.labels?.close?.[languageObj?.id]}
                                    type='reset'
                                    onClick={() => defaultValueSetAsync(true)}>
                                    <i className={globalSettings?.icons?.arrowCircleLeft}></i>
                                </button>
                            </div>
                        </div> */}
                    {/* </form> */}
                    {/* </div> */}
                </Modal.Body>
                <Modal.Footer>
                    <div className='form-group text-right'>
                        <button id={controls?.buttons?.save?.id}
                            className={controls?.buttons?.save?.className}
                            tooltip='tooltip'
                            title={globalSettings?.labels?.save?.[languageObj?.id]}
                            type='submit'>
                            <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                        </button>
                        <button className='btn btn-outline-success'
                            tooltip='tooltip'
                            title={globalSettings?.labels?.close?.[languageObj?.id]}
                            type='reset'
                            onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnBack' })}>
                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}